import React, { useEffect, useState } from 'react'
import { Tab, TabList, Tabs } from './styles'

import { useHistory } from 'react-router-dom'
import { useQueryParams } from '@monorepo/infra'

interface TabsListProps {
  tabKey: string
  tabs: {
    description: string
    tabName: string
  }[]
  // Which tab is selected when the URL has no tabKey param yet. Defaults to
  // the first tab (existing behavior); pass a tabName to override.
  defaultTabName?: string
}

const TabsList: React.FC<TabsListProps> = ({
  tabKey,
  tabs,
  defaultTabName,
}) => {
  const history = useHistory()
  const queryParams = useQueryParams()
  const defaultTabIndex = Math.max(
    0,
    tabs.findIndex((tab) => tab.tabName === defaultTabName)
  )
  const [currentTabIndex, setCurrentTabIndex] = useState(defaultTabIndex)

  const handleChangeTab = (tabIndex: number) => {
    const selectedTab = tabs[tabIndex]

    if (!selectedTab) return

    setCurrentTabIndex(tabIndex)

    history.push(`?${tabKey}=${selectedTab.tabName}`)
  }

  useEffect(() => {
    const searchOriginal = queryParams.toString()
    const hasSearchParam = queryParams.has(tabKey)

    if (!hasSearchParam) {
      setCurrentTabIndex(defaultTabIndex)

      history.push({
        search: `${!!searchOriginal ? `${searchOriginal}&` : ''}${tabKey}=${
          tabs[defaultTabIndex]?.tabName
        }`,
      })
    } else {
      const tabName = queryParams.get(tabKey)
      const tmpIndex = tabs.findIndex((item) => item.tabName === tabName)

      if (tmpIndex !== -1 && tmpIndex !== currentTabIndex) {
        setCurrentTabIndex(tmpIndex)
      }
    }
  }, [history, queryParams, tabKey, tabs, defaultTabIndex])

  return (
    <Tabs onChange={(index) => handleChangeTab(index)} index={currentTabIndex}>
      <TabList>
        {tabs.map(({ description, tabName }, index) => (
          <Tab key={tabName} index={index} tabIndex={index}>
            {description}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  )
}

export default TabsList
